<div class="become-leader">
  <div class="flex flex-column align-items-center justify-content-center">
    <!-- <span class="text-center grey-text">Vuoi organizzare viaggi di gruppo?</span> -->
    <h2 class="text-center mt-1">
      Vuoi organizzare viaggi di gruppo? Diventa
      <span class="yellow">Tour Leader!</span>
      <img src="/assets/media/icons/support.png" width="30" />
    </h2>
  </div>
  <div class="grid mt-3 led">
    <div class="col-12 md:col-6">
      <div class="img-container-leader ml-3">
        <div class="img-3"></div>
      </div>
    </div>
    <div class="col-12 md:col-6">
      <div class="ml-3 flex flex-column justify-content-between h-full">
        <p class="m-0 mb-3">
          Trasforma la tua passione per i viaggi in un’opportunità unica! Con
          Socialtravels, creare e condividere i tuoi itinerari è facile e
          veloce. Diventa un punto di riferimento per la tua community e inizia
          a progettare esperienze completamente personalizzate e
          indimenticabili. Siamo al tuo fianco per supportarti in ogni fase:
          dall’ideazione del viaggio alla promozione, dalla gestione dei
          partecipanti all'assistenza in loco. Essere Tour Leader significa
          guidare le persone alla scoperta del mondo, con entusiasmo, competenza
          e spirito di gruppo. Se hai un’idea, una destinazione nel cuore o una
          community pronta a partire, sei nel posto giusto: crea oggi stesso il
          tuo primo viaggio con noi!
        </p>
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="stripe-y flex align-items-center gap-3">
              <img src="/assets/media/icons/ok.png" width="30" />
              <small>Valutazione preventivi</small>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="stripe-y flex align-items-center gap-3">
              <img src="/assets/media/icons/ok.png" width="30" />
              <small>Gestione inviti</small>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="stripe-y flex align-items-center gap-3">
              <img src="/assets/media/icons/ok.png" width="30" />
              <small>Controllo iscrizioni</small>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="stripe-y flex align-items-center gap-3">
              <img src="/assets/media/icons/ok.png" width="30" />
              <small>Gestione pagamenti (acconto e saldo)</small>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="stripe-y flex align-items-center gap-3">
              <img src="/assets/media/icons/ok.png" width="30" />
              <small>Comunicazioni dirette ai partecipanti</small>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="stripe-y flex align-items-center gap-3">
              <img src="/assets/media/icons/ok.png" width="30" />
              <small>Contatti con i fornitori</small>
            </div>
          </div>
        </div>
        <div class="text-center b-container">
          <p-button
            styleClass="px-6 slide md:mt-4 mt-6"
            label="Diventa Tour Leader"
            routerLink="/tour-leader/leader-landing"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
</div>
